import { Component, OnInit, Inject, LOCALE_ID } from '@angular/core';
import {Location} from '@angular/common';
import { DateService } from 'app/shared/date.service';
import { IntlService, CldrIntlService } from '@progress/kendo-angular-intl';
import { AppSettings } from 'app/shared/app-settings';
//import { IMyOptions } from 'mydatepicker';
import  '@progress/kendo-angular-intl/locales/he/all';
import { FormGroup , FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { stringify } from '@angular/core/src/util';
import { AdminService } from '../../admin.service';
import { Router } from '@angular/router';
import { refreshDescendantViews } from '@angular/core/src/render3/instructions';
import { IPrefixMobile } from '../../model/kod-mobile-prefix';
import { DebugRenderer2 } from '@angular/core/src/view/services';
import { setData } from '@telerik/kendo-intl';
import { debug } from 'util';
import { ResultOfOperation } from 'app/shared/model/result-of-operation.model';
import { IOved } from 'app/admin/interface/ioved.interface';
import { Moment } from "moment";
import { UserMessagesComponent } from 'app/shared/user-messages/user-messages.component';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { identifierModuleUrl } from '@angular/compiler';
import { routerNgProbeToken } from '@angular/router/src/router_module';
import { ConfirmService } from 'app/shared/dialog/confirm.service';
import { setTime } from '@progress/kendo-angular-dateinputs/dist/es2015/util';
import { Oved } from 'app/shared/model/oved';
import { ConfirmDialogComponent } from 'app/shared/dialog/confirm-dialog/confirm-dialog.component';
import { ViewportScrollPosition } from '@angular/cdk/scrolling';
import { NofeshService } from 'app/nofesh/nofesh.service';
import { INofesh } from 'app/nofesh/model/nofesh';
import { filter } from 'rxjs-compat/operator/filter';
import { CustomValidators } from 'ng2-validation';
import { Key } from 'protractor';
import { AddNofeshAdmin } from 'app/admin/model/add-nofesh-admin';
//import moment = require('moment');
import * as moment from 'moment'
import { ENofeshType } from 'app/shared/enums/enofesh-type.enum';
declare var require: any;



interface IKeyValue {
  key: number;
  value: string;
}

interface IKeyValueTentative {
  key: number;
  value: string;
  secondValue: string;

}

@Component({
  selector: 'app-add-nofesh-meurgan',
  templateUrl: './add-nofesh-meurgan.component.html',
  styleUrls: ['./add-nofesh-meurgan.component.css']
})
export class AddNofeshMeurganComponent implements OnInit {
  moment = require("moment");
  constructor(
      
    @Inject(LOCALE_ID) public localeId: string,
    public intlService: IntlService,
    private fb:FormBuilder,
    private _adminService:AdminService,      
    private location: Location,
    private _userMessagesService: UserMessagesService,
    private dialog: MatDialog,
    private router: Router,
    private confirmService: ConfirmService,
    private _nofeshService: NofeshService,
    
    ) { }
  


test()
{
  
  var newRishumFrom = moment(this.adminForm.get('rishum_from').value).add('hours',14);
  console.log(newRishumFrom);
  
}

  ngOnInit() {
    this._userMessagesService.clearAll();
    moment.locale("he");
    this.hours = ['8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23'];
    this.minutes = ['00','05','10','15','20','25','30','35','40','45','50','55'];
   

    this._adminService.getPriceTypeMeurgan().subscribe(result => {
      result.data.forEach(element => {
      this.priceType.push({key:element.idPriceType,value:element.teurPrice});
      });
      console.log(this.priceType);
    })
    
  }

  priceType: IKeyValue[] =[ 
  {
    key: 0 ,value : "בחר"
  }]

  allNofeshTitles: IKeyValueTentative[] = [
    { key: 0, value: "בחר", secondValue:""}
  ]
  isIdNofeshTitleSelected:boolean = true;
  rishum_from_wrong_pattern:boolean = false;
  rishum_to_wrong_pattern:boolean = false;
  nofesh_from_wrong_pattern: boolean = false;
  nofesh_to_wrong_pattern: boolean = false;
  isTentative:boolean = undefined;
  revealFormAfterChangeTentative:boolean = false;
  selectedNofeshId:number = 0;
  nofashimFullDetails:INofesh[] = [];
  maxSelectedNofeshId: Number = 0;
  revealForm:boolean = undefined;
  hours:string[] = [];
  minutes:string[] = [];
  isNofeshTypeNofshon: boolean = false;
  teur_sug_cheder:string;
  readonly DEFAULT_RISHUM_FROM_HOUR : string = "16:00";

  get nofesh_title() { return this.adminForm.get('nofesh_title'); }
  get id_nofesh_type_error() {return this.adminForm.get('id_nofesh_type');}
  get rishum_from(){return this.adminForm.get('rishum_from')};
  get rishum_to(){return this.adminForm.get('rishum_to')};
  get nofesh_from(){return this.adminForm.get('nofesh_from')};
  get nofesh_to(){return this.adminForm.get('nofesh_to')};
  get total_peaple_error(){return this.adminForm.get('total_peaple')};
  get total_rooms_error(){return this.adminForm.get('total_rooms')};
  get heara1_error(){return this.adminForm.get('heara1')};
  get heara2_error(){return this.adminForm.get('heara2')};
  get heara3_error(){return this.adminForm.get('heara2')};
  get total_hamtana_room_error(){return this.adminForm.get('total_hamtana_room')};
  get total_hamtana_people_error(){return this.adminForm.get('total_hamtana_people')};

  adminForm = this.fb.group({
    nofeshTitle: [0],
    nofesh_title:[''],
    tentitive:[-1],
    id_nofesh_type:[-1],
    rishum_from:[,Validators.compose([Validators.maxLength(10),Validators.minLength(10),Validators.required])],
    rishum_to:[,Validators.compose([Validators.maxLength(10),Validators.minLength(10),Validators.required])],
    nofesh_from:[,Validators.compose([Validators.maxLength(10),Validators.minLength(10),Validators.required])],
    nofesh_to:[,Validators.compose([Validators.maxLength(10),Validators.minLength(10),Validators.required])],
    total_rooms:[20,Validators.compose([Validators.min(1),Validators.required])],
    total_peaple:[1000,Validators.compose([Validators.required,Validators.min(1)])],
    board_type:[2],
    company:[''],
    companySite:[''],
    hotelName:[''],
    heara1:[,Validators.compose([Validators.maxLength(250)])],
    heara2:[,Validators.compose([Validators.maxLength(250)])],
    heara3:[,Validators.compose([Validators.maxLength(250)])],
    isSyllabusUploaded:[1],
    hotel_star_rating:[3],
    total_hamtana_room:[0,Validators.compose([Validators.min(1),Validators.required])],
    total_hamtana_people:[0,Validators.compose([Validators.min(1),Validators.required])],
    child_min_age:[2],
    child_max_age:[12],
    id_nofesh_mekushar:[],
    id_machzor:[],
    k_pail:[1],
    shana:[2020],
    price_id_1:[0],
    price_id_2:[0],
    price_id_3:[0],
    price_id_4:[0],
    price_id_5:[0],
    price_id_6:[0],
    price_id_7:[0],
    price_id_19:[0],
    price_id_15:[0],
    price_id_16:[0],
    price_id_17:[0],
    price_id_11:[0],
    price_id_12:[0],
    price_id_13:[0],
    rishum_from_hour:[this.DEFAULT_RISHUM_FROM_HOUR.split(":")[0]],
    rishum_from_minutes:[this.DEFAULT_RISHUM_FROM_HOUR.split(":")[1]],
    sug_cheder:[],
    numberOfRooms:[20],
    numberOfRoomsHamtana:[50]
  })

 
  validateIdNofeshType():boolean{

    if(this.adminForm.get('id_nofesh_type').value==-1){
      this.isIdNofeshTitleSelected=false;}
    else
    {
      this.isIdNofeshTitleSelected=true;
      if(this.adminForm.get('id_nofesh_type').value==3 ||this.adminForm.get('id_nofesh_type').value==5 || this.adminForm.get('id_nofesh_type').value==1)
      {
        //means that nofshon type was selected
        this.isNofeshTypeNofshon = true;
      }

    }   
  if(!this.isIdNofeshTitleSelected){
    return false;
  }
  else
  return true;
  }

  TrRishumFromValidator()
  {
    
    let rishumFrom = this.adminForm.value.rishum_from;
    if(!this.moment.isMoment(rishumFrom))
    {
      this.rishum_from_wrong_pattern = true;
    }
    else
    {
      this.rishum_from_wrong_pattern = false;
    }
   
  }
  TrRishumToValidator()
  {
    
    let rishumTo = this.adminForm.value.rishum_to;
    if(!this.moment.isMoment(rishumTo))
    {
      this.rishum_to_wrong_pattern = true;
    }
    else
    {
      this.rishum_to_wrong_pattern = false;
    }
   
  }
  TrNofeshFromValidator()
  {
    let nofeshFrom = this.adminForm.value.nofesh_from;
    if(!this.moment.isMoment(nofeshFrom))
    {
      this.nofesh_from_wrong_pattern = true;
    }
    else
    {
      this.nofesh_from_wrong_pattern = false;
    }
   
  }
  TrNofeshToValidator()
  {
    let nofeshTo = this.adminForm.value.nofesh_to;
    if(!this.moment.isMoment(nofeshTo))
    {
      this.nofesh_to_wrong_pattern = true;
    }
    else
    {
      this.nofesh_to_wrong_pattern = false;
    }
   
  }

  revealAllFields()
  {
    
    this.adminForm.patchValue({"id_machzor":1})

    let tentative = this.adminForm.value.tentitive;
    if(tentative == 0)
    {
      this.getNofeshDetails();
      this.revealForm = true;
      this.isTentative = false;
    }
    else if(tentative == 1)
    {
     this.getAllNofshonim();
      this.isTentative = true;
    }
    else
    {
      this.revealForm = true;
      this.isTentative = false;
    }
  }

  getNofeshDetails()
  {
      if(this.isTentative==true)
      { 
        this.revealForm = true;
          this.selectedNofeshId = this.adminForm.value.nofeshTitle;
          this._adminService.getDataForNofeshTentative(this.selectedNofeshId).subscribe(result=>{
            if(result!=null&&result.isSuccess)
            {

               var allNofeshTitlesForSpecificNofeshName : IKeyValue[] = [];
               Object.assign(allNofeshTitlesForSpecificNofeshName,this.allNofeshTitles);
               var currentSelectedNofesh = allNofeshTitlesForSpecificNofeshName.filter(result=>result.key==this.adminForm.get("nofeshTitle").value)
   
               
              //console.log(result.data);
              this.adminForm.patchValue({'nofesh_title':currentSelectedNofesh[0].value});
              this.adminForm.patchValue({"id_machzor":(Number(result.data.max_machzor)+1)})      
              this.adminForm.patchValue({"id_nofesh_mekushar":this.selectedNofeshId})      
              this.adminForm.patchValue({"k_pail":(0)});
              this.adminForm.patchValue({"price_id_1":result.data.price_type_1});
              this.adminForm.patchValue({"price_id_2":result.data.price_type_2});
              this.adminForm.patchValue({"price_id_3":result.data.price_type_3});
              this.adminForm.patchValue({"price_id_4":result.data.price_type_4});
              this.adminForm.patchValue({"price_id_5":result.data.price_type_5});
              this.adminForm.patchValue({"price_id_6":result.data.price_type_6});
              this.adminForm.patchValue({"price_id_7":result.data.price_type_7});
              this.adminForm.patchValue({"price_id_19":result.data.price_type_19});
              this.adminForm.patchValue({"price_id_15":result.data.price_type_15});
              this.adminForm.patchValue({"price_id_16":result.data.price_type_16});
              this.adminForm.patchValue({"price_id_17":result.data.price_type_17});
              this.adminForm.patchValue({"price_id_11":result.data.price_type_11});
              this.adminForm.patchValue({"price_id_12":result.data.price_type_12});
              this.adminForm.patchValue({"price_id_13":result.data.price_type_13});
              
            }
          })
          let tempNofashimAlldetails:INofesh[]=[];
           Object.assign(tempNofashimAlldetails,this.nofashimFullDetails);
          tempNofashimAlldetails = tempNofashimAlldetails.filter(nofesh=>nofesh.id_nofesh == this.selectedNofeshId);
      }
      else
      {     
         
        
        this.adminForm.patchValue({"id_machzor":1})
        this.adminForm.patchValue({"k_pail":(1)})
        

      
        
        
        
        //istentative = false
      }

      
  }
  getAllNofshonim() {
    this._nofeshService.getAllNofashim().subscribe(res => {
      if (res.isSuccess) {
        console.log("res",res);
        Object.assign(this.nofashimFullDetails,res);
        let nofshonim = res.data;
        
        //get all nofshonim except the current one in reservatiuon.
        nofshonim = nofshonim.filter(nofshonim => (nofshonim.nofeshType == ENofeshType.NofeshChul || nofshonim.nofeshType == ENofeshType.NofeshPnim) && nofshonim.k_pail == 1 && nofshonim.id_machzor == 1)
        
        this.allNofeshTitles = this._adminService.getAllNofshonimTitles(nofshonim);
        console.log('nofshonimTitles',this.allNofeshTitles)

      }
      else {
        this._userMessagesService.setErrorMessage("לא קיימים נופשונים - אנא פנה למנהל המערכת")
      }
    })

  }

  testDates()
  {

 moment(this.adminForm.value.rishum_from.set({hour:this.adminForm.value.rishum_from_hour,minute:this.adminForm.value.rishum_from_minutes,second:0,millisecond:0})).utcOffset(-2);
    

  }
getTeurCheder($event)
{
  try
  {
    this.teur_sug_cheder = $event.target.options[$event.target.options.selectedIndex].text;
    
  }
  catch{}
}

  sendData()
  {
    var nofeshToSend  = new  AddNofeshAdmin()
    nofeshToSend.id_nofesh =  this.adminForm.value.nofeshTitle;
    nofeshToSend.id_nofesh_mekushar = this.adminForm.value.id_nofesh_mekushar;
    nofeshToSend.id_nofesh_type = this.adminForm.value.id_nofesh_type;
    nofeshToSend.isSyllabusUploaded = this.adminForm.value.isSyllabusUploaded;
    nofeshToSend.k_pail = this.adminForm.value.k_pail;
    nofeshToSend.nofesh_from = this.adminForm.value.nofesh_from;
    nofeshToSend.nofesh_title = this.adminForm.value.nofesh_title;
    nofeshToSend.nofesh_to = this.adminForm.value.nofesh_to;
    nofeshToSend.price_id_1 = this.adminForm.value.price_id_1;
    nofeshToSend.price_id_2 = this.adminForm.value.price_id_2;
    nofeshToSend.price_id_3 = this.adminForm.value.price_id_3;
    nofeshToSend.price_id_4 = this.adminForm.value.price_id_4
    nofeshToSend.price_id_5 = this.adminForm.value.price_id_5;
    nofeshToSend.price_id_6 = this.adminForm.value.price_id_6;
    nofeshToSend.price_id_7 = this.adminForm.value.price_id_7;
    nofeshToSend.price_id_19 = this.adminForm.value.price_id_19;
    nofeshToSend.price_id_15 = this.adminForm.value.price_id_15;
    nofeshToSend.price_id_16 = this.adminForm.value.price_id_16;
    nofeshToSend.price_id_17 = this.adminForm.value.price_id_17;
    nofeshToSend.price_id_11 = this.adminForm.value.price_id_11;
    nofeshToSend.price_id_12 = this.adminForm.value.price_id_12;
    nofeshToSend.price_id_13 = this.adminForm.value.price_id_13;
    nofeshToSend.rishum_from =  moment(this.adminForm.value.rishum_from.set({hour:this.adminForm.value.rishum_from_hour,minute:this.adminForm.value.rishum_from_minutes,second:0,millisecond:0})).utcOffset(-2);
    nofeshToSend.rishum_to = this.adminForm.value.rishum_to;
    nofeshToSend.shana = this.adminForm.value.shana;
    nofeshToSend.tentitive = this.adminForm.value.tentitive;
    nofeshToSend.total_hamtana_people = this.adminForm.value.total_hamtana_people;
    nofeshToSend.total_hamtana_room = this.adminForm.value.total_hamtana_room;
    nofeshToSend.total_peaple = this.adminForm.value.total_peaple;
    nofeshToSend.total_rooms = this.adminForm.value.total_rooms;
    nofeshToSend.board_type = this.adminForm.value.board_type;
    nofeshToSend.child_max_age = this.adminForm.value.child_max_age;
    nofeshToSend.child_min_age = this.adminForm.value.child_min_age;
    nofeshToSend.company = this.adminForm.value.company;
    nofeshToSend.companySite = this.adminForm.value.companySite;
    nofeshToSend.heara1 = this.adminForm.value.heara1;
    nofeshToSend.heara2 = this.adminForm.value.heara2;
    nofeshToSend.heara3 = this.adminForm.value.heara3;
    nofeshToSend.hotelName = this.adminForm.value.hotelName;
    nofeshToSend.hotel_star_rating = this.adminForm.value.hotel_star_rating;
    nofeshToSend.id_machzor = this.adminForm.value.id_machzor;
    
    nofeshToSend.sug_cheder = this.adminForm.value.sug_cheder;
    nofeshToSend.teur_sug_cheder = this.teur_sug_cheder;
    nofeshToSend.numberOfRooms = this.adminForm.value.numberOfRooms;
    nofeshToSend.numberOfRoomsHamtana = this.adminForm.value.numberOfRoomsHamtana;
        
    
    this._adminService.addNewNofesh(nofeshToSend).subscribe(result =>{
      if(result.isSuccess)
      {
        this._userMessagesService.setSuccessMessage("הוספת נופש עברה בהצלחה");
      }
      else
      {
        this._userMessagesService.setErrorMessage("בעיה בהוספת נופש");
      }
    })
    
  }


   findInvalidControls() {
    const invalid = [];
    const controls = this.adminForm.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    console.log(invalid)
;}
  
}
